import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { userAPI } from '../api/user';
import { authAPI } from '../api/auth';

function UserInfo({ studyCount = 0, currentPage = '' }) {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      return;
    }

    const fetchUserInfo = async () => {
      try {
        const data = await userAPI.getUserInfo();
        setUserInfo(data);
      } catch (error) {
        console.error('获取用户信息失败', error);
      }
    };

    fetchUserInfo();

    const handleAvatarUpdate = () => {
      fetchUserInfo();
    };
    window.addEventListener('avatar-updated', handleAvatarUpdate);
    const handleScoreUpdate = () => {
      fetchUserInfo();
    };
    window.addEventListener('score-updated', handleScoreUpdate);
    return () => {
      window.removeEventListener('avatar-updated', handleAvatarUpdate);
      window.removeEventListener('score-updated', handleScoreUpdate);
    };
  }, []);

  const handleClickOutside = useCallback((e) => {
    if (showPopup && !e.target.closest('.user-info-popup') && !e.target.closest('.user-info-toggle')) {
      setShowPopup(false);
    }
  }, [showPopup]);

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [handleClickOutside]);

  const handleToggle = (e) => {
    e.stopPropagation();
    setShowPopup(prev => !prev);
  };

  const handleCancel = (e) => {
    e?.stopPropagation();
    setShowPopup(false);
  };

  const handleLogout = async (e) => {
    e?.stopPropagation();
    try {
      await authAPI.logout();
    } catch (error) {
      console.error('登出API调用失败', error);
    }
    localStorage.removeItem('token');
    window.location.href = '/';
  };

  const handleNavigate = (path) => {
    setShowPopup(false);
    navigate(path);
  };

  const formatStudyTime = (minutes) => {
    if (!minutes && minutes !== 0) return '0分钟';
    const totalMinutes = Number(minutes);
    if (totalMinutes < 60) {
      return `${totalMinutes}分钟`;
    }
    const hours = Math.floor(totalMinutes / 60);
    const mins = totalMinutes % 60;
    if (mins === 0) {
      return `${hours}小时`;
    }
    return `${hours}小时${mins}分`;
  };

  if (!localStorage.getItem('token')) {
    return null;
  }

  const navItems = [
    { label: '学习', path: '/study', key: 'study' },
    { label: '古诗挑战', path: '/game', key: 'game' },
    { label: '积分兑换', path: '/exchange', key: 'exchange' },
    { label: '个人设置', path: '/personal', key: 'personal' },
  ];

  return (
    <div className="user-info-toggle" onClick={handleToggle}>
      <div className="user-avatar">
        {userInfo?.avatar ? (
          <img src={userInfo.avatar} alt="头像" />
        ) : (
          <div className="avatar-placeholder">头</div>
        )}
      </div>
      {showPopup && (
        <div className="user-info-popup">
          <div className="popup-header">
            <h4>个人信息</h4>
          </div>
          <div className="popup-content">
            <div className="popup-avatar">
              {userInfo?.avatar ? (
                <img src={userInfo.avatar} alt="头像" />
              ) : (
                <div className="avatar-placeholder">头</div>
              )}
            </div>
            <div className="popup-info">
              <div className="info-item">
                <span className="label">昵称：</span>
                <span className="value">{userInfo?.nickname || ''}</span>
              </div>
              <div className="info-item">
                <span className="label">元宝积分：</span>
                <span className="value">{userInfo?.score || 0}</span>
              </div>
              <div className="info-item">
                <span className="label">学习古诗：</span>
                <span className="value">{studyCount} 首</span>
              </div>
              <div className="info-item">
                <span className="label">学习时长：</span>
                <span className="value">{formatStudyTime(userInfo?.studyTime)}</span>
              </div>
            </div>
          </div>
          <div className="popup-nav">
            {navItems.filter(item => item.key !== currentPage).map(item => (
              <button
                key={item.key}
                className="nav-item"
                onClick={() => handleNavigate(item.path)}
              >
                {item.label}
              </button>
            ))}
          </div>
          <div className="user-info-popup-footer">
            <button type="button" className="user-info-cancel-btn" onClick={handleCancel}>取消</button>
            <button type="button" className="user-info-logout-btn" onClick={handleLogout}>退出程序</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default UserInfo;
